import { useNavigate } from "react-router-dom";

/**
 * Row component to display a row with an icon, text, and a button.
 *
 * @param {Object} props
 * @param {boolean} props.ok
 * @param {string} props.btnLabel
 * @param {string} props.btnHref
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
function Row({ ok, btnLabel, btnHref, children }) {
    const navigate = useNavigate();
    const icon = ok ?
        "icon-confirmation icon--primary-green"
        :
        "icon-info icon--primary-blue"

    return <div className="row" style={{ display: "flex", alignItems: "center", padding: "1.5rem" }}>
        <div className="col-sm-1">
            <span className={`geico-icon ${icon}`} style={{ display: "flex" }} />
        </div>
        <div className="col-sm-11 col-md-5 col-lg-7">
            {children}
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
            <button
                type="button"
                className="btn btn--primary btn--full"
                style={{ margin: "0rem" }}
                onClick={() => navigate(btnHref)}
            >
                Submit {ok ? "New" : null} {btnLabel}
            </button>
        </div>
    </div>
}

/**
 * BankTabContent component to manage W-9 and Banking Details.
 *
 * @param {Object} props
 * @param {boolean|*} props.w9 - Indicates if W-9 is submitted.
 * @param {boolean|*} props.hasAcct - Indicates if a bank account exists.
 * @param {string|null} props.acctNumber - The last 4 of the bank account number.
 * @param {string|null} props.acctType - The type of bank account: checking, savings, etc.
 * @returns {JSX.Element}
 */
export default function BankTabContent({ w9, hasAcct, acctNumber, acctType }) {
    return (
        <div className="col-sm-12 padding-top">
            <div className="component-page-headers">
                <h3>Manage W-9 and Banking&nbsp;Details</h3>
            </div>
            <Row ok={w9} btnHref={"/onboarding-commission-tax-form"} btnLabel={"W-9"}>
                {
                    w9 ?
                        <>
                            <div>W-9 Submitted Electronically</div>
                            <div className="small-text">Your tax information is on file.</div>
                        </>
                        :
                        <div>No tax information on file.</div>
                }
            </Row>
            <Row ok={!!acctNumber} btnHref={"/commission-banking-details"} btnLabel={"Bank Info"}>
                <div>
                    {hasAcct === false ? "No" : "Current"} Payout&nbsp;Method On&nbsp;File
                </div>
                {
                    <div className="small-text">
                        {acctNumber ?
                            <>{acctType ?? "Bank"} account ending in {acctNumber}</>
                            :
                            hasAcct === false ?
                                <>We don't have your banking details on record</>
                                :
                                <>Your bank information is currently unavailable</>
                        }
                    </div>
                }
            </Row>
        </div>
    );
};
